import type { ReactNode } from 'react';
import { Icon } from './icons';
import { Badge, PageHeader } from './ui';

/**
 * Gerçek API'de ucu henüz olmayan ekranlar için dürüst "yakında" durumu.
 * Mock modda (VITE_MOCK=1) ilgili ekranlar örnek veriyle çalışmaya devam eder.
 */
export function ComingSoon({
  title,
  description,
  endpoints
}: {
  title: string;
  description: string;
  endpoints: string[];
}) {
  return (
    <div>
      <PageHeader title={title} subtitle="Bu ekran gerçek API'ye henüz bağlanmadı." />
      <div className="p-6">
        <div className="panel max-w-[720px] p-5">
          <div className="flex items-center gap-2">
            <Badge tone="warn">Yakında</Badge>
            <span className="text-[11px] text-muted">Backend uçları geliştiriliyor</span>
          </div>
          <h2 className="mt-3 text-[14px]">Bu ekran şu an salt-okur bilgi gösteriyor</h2>
          <p className="mt-1 text-[12px] leading-5 text-ink-2">{description}</p>

          <div className="mt-4">
            <div className="eyebrow mb-1">Beklenen uçlar</div>
            <ul className="space-y-1">
              {endpoints.map((endpoint) => (
                <li key={endpoint} className="mono rounded-[4px] border border-line bg-paper px-2 py-1 text-[11px] text-ink-2">
                  {endpoint}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-4 flex items-start gap-2 rounded-[4px] border border-line bg-paper px-3 py-2 text-[11px] text-muted">
            <Icon name="shield" size={14} className="mt-0.5 shrink-0" />
            <span>
              Bu fazda yalnız gelen kutusu, konuşma, kişiler, test modu ve bağlantı ekranları gerçek API'ye bağlı.
              Diğer ekranları örnek veriyle denemek için paneli <span className="mono">VITE_MOCK=1</span> ile çalıştırın.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

/** Route seviyesinde özellik kapısı: uç yoksa "yakında" gösterir. */
export function FeatureGate({
  available,
  children,
  title,
  description,
  endpoints
}: {
  available: boolean;
  children: ReactNode;
  title: string;
  description: string;
  endpoints: string[];
}) {
  if (available) return <>{children}</>;
  return <ComingSoon title={title} description={description} endpoints={endpoints} />;
}
